export default "__VITE_ASSET__CgEofyyB__"